export function formatContactDisplay(
    name: string | null | undefined,
    email: string | null | undefined,
    resolvedName?: string | null,
): string {
    const displayName = resolvedName || name;
    if (displayName && email && displayName !== email) {
        return `${displayName} <${email}>`;
    }
    return email || displayName || "";
}
